import { FC, useCallback, useMemo } from "react";

import { MoreHoriz } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

type IProps = {
  id: string;
  isDefault?: boolean;
  onEdit(id: string, openOldBuilder?: boolean): void;
  onDelete(id: string): void;
  onDuplicate(id: string, openOldBuilder?: boolean): void;
  disabled: boolean;
  openOldBuilder?: boolean;
};
export const ContactFormContextMenu: FC<IProps> = ({
  id,
  isDefault = false,
  onEdit,
  onDelete,
  onDuplicate,
  disabled,
  openOldBuilder,
}) => {
  const handleEdit = useCallback(() => {
    onEdit(id, openOldBuilder);
  }, [id, onEdit, openOldBuilder]);

  const handleDelete = useCallback(() => {
    onDelete(id);
  }, [id, onDelete]);

  const handleDuplicate = useCallback(() => {
    onDuplicate(id, openOldBuilder);
  }, [id, onDuplicate, openOldBuilder]);

  const items = useMemo<IActionMenuOption[]>(() => {
    const menuItems = [
      {
        key: "edit",
        element: <ActionMenuItem data-testid="edit-context-menu-item">Edit</ActionMenuItem>,
        onClick: handleEdit,
      },
      {
        key: "duplicate",
        element: <ActionMenuItem data-testid="duplicate-context-menu-item">Duplicate</ActionMenuItem>,
        onClick: handleDuplicate,
      },
    ];

    if (!isDefault) {
      menuItems.push({
        key: "delete",
        element: (
          <ActionMenuItem data-testid="delete-context-menu-item" kind="warning">
            Delete
          </ActionMenuItem>
        ),
        onClick: handleDelete,
      });
    }

    return menuItems;
  }, [disabled, handleEdit, handleDuplicate, isDefault, handleDelete]);

  return (
    <ActionMenu
      triggerRenderer={
        <Button
          kind="plain"
          size="compact"
          disabled={disabled}
          icon={<Icon source={MoreHoriz} />}
          css={{ marginLeft: "-16px" }}
        />
      }
      options={items}
    />
  );
};
